// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const StatusOfflineIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "StatusOffline/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922c.05.062.106.118.168.167l6.911 6.911a1 1 0 0 0 1.414-1.414l-.675-.675a9.001 9.001 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7.002 7.002 0 0 1 .657 9.143l-1.435-1.435a5.002 5.002 0 0 0-.636-6.294 1 1 0 1 0-1.414 1.415c.923.923 1.119 2.3.586 3.415l-1.992-1.992a.922.922 0 0 0-.018-.018l-6.99-6.991ZM3.238 8.187a1 1 0 1 0-1.933-.516c-.8 3-.025 6.336 2.331 8.693a1 1 0 0 0 1.414-1.415 6.997 6.997 0 0 1-1.812-6.762ZM7.4 11.5a1 1 0 1 0-1.73 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.414-1.414c-.191-.191-.35-.4-.478-.622Z"
}));
export default StatusOfflineIcon;